<template>
    <div class="container">
        <a :href="'/customer/'+this.customer_id"> &lt;&lt; Atgal </a>
        <div class="card">
            <div class="card-header">
                Esamas subranga
                <button class="btn btn-danger float-right" @click="deleteOrder" onclick="return(false)">Trinti</button>
            </div>
            <div class="card-body">
                <div class="form-row">
                    <div class="col-12 col-md-6">
                        <label for="eq_id">Įranga</label>
                        <!--<select class="form-control" id="eq_id" v-model="new_equipment">-->
                        <!--<option v-for="e in equipment" :value="{id:e.id, text:e.name, price:e.price, power:e.power, equipment_type_id: e.equipment_type_id}">{{ e.name }}</option>-->
                        <!--</select>-->

                        <v-select v-if="equipment" class="vue-select2s" id="eq_id" name="select2"
                                  :options="equipment" label="long_name"
                                  :model.sync="new_equipment"
                                  v-model="new_equipment"
                                  :searchable="true" language="en-US">
                        </v-select>
                    </div>
                    <div class="col-6 col-md-3">
                        <label for="eq_qty">Kiekis</label>
                        <input id="eq_qty" class="form-control" @keyup="enter_submit" v-model="new_equipment_qty"
                               type="text">
                    </div>
                    <div class="col-6 col-md-3">
                        <label for="">&nbsp;</label>
                        <button @click="add_equipment_to_offer" class="form-control btn btn-outline-success">Pridėti
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="form-row border-bottom mb-4 p-1" v-for="(se, i) in selected_equipment">

                    <!-- gautas is api -->
                    <div v-if="!se.equipment_text" @click="deleteOldSelected(i, se)"
                         class="col-1 text-danger font-weight-bold my-auto">-
                    </div>
                    <div class="col-9 col-md-6 my-auto" v-if="!se.equipment_id">{{ se.name }} -- {{ se.pivot.quantity }} vnt.

                    </div>
                    <div class="col-1" v-if="!se.equipment_id">
                        Vnt.:<input type="text" class="form-control" @focus="onFocus" v-model="se.pivot.quantity">
                    </div>
                    <div class="col-2" v-if="!se.equipment_id">
                        Vieneto kaina:<input type="text" class="form-control" @focus="onFocus" v-model="se.pivot.price">
                    </div>
                    <div class="col-2" v-if="!se.equipment_id">
                        su PVM:<input type="text" class="form-control" @focus="onFocus" readonly :value="(se.pivot.price *1.21).toFixed(2)">
                    </div>

                    <!-- naujai idetas -->
                    <div v-if="se.equipment_text" @click="deleteSelected(i, se.price, se.quantity)" class="col-1">-
                    </div>
                    <div class="col-11 col-md-6" v-if="se.equipment_text">{{ se.equipment_text }} -- {{ se.quantity }}
                        vnt.
                    </div>
                </div>


                <div class="form-row">
                    <div class="col-12 col-lg-2">
                        <div class="form-group">
                            <label for="price">Kodas-1</label>
                            <div class="input-group">
                                <input id="code_1" class="form-control" type="text" v-model="subcontract.code_1">
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-8">
                        <div class="form-group">
                            <label for="price">Pavadinimas-1</label>
                            <div class="input-group">
                                <input id="text_1" class="form-control" type="text" v-model="subcontract.text_1">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2">
                        <div class="form-group">
                            <label for="price">Kaina-1 <span class="small">be PVM</span></label>
                            <div class="input-group">
                                <input id="price_1" @focus="onFocus" @keyup="delete_comma" class="form-control" type="text" v-model="subcontract.price_1">
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="form-row">
                    <div class="col-12 col-lg-2">
                        <div class="form-group">
                            <label for="price">Kodas-2</label>
                            <div class="input-group">
                                <input id="code_2" class="form-control" type="text" v-model="subcontract.code_2">
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-8">
                        <div class="form-group">
                            <label for="price">Pavadinimas-2</label>
                            <div class="input-group">
                                <input id="text_2" class="form-control" type="text" v-model="subcontract.text_2">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2">
                        <div class="form-group">
                            <label for="price">Kaina-2 <span class="small">be PVM</span></label>
                            <div class="input-group">
                                <input id="price_2" @focus="onFocus" @keyup="delete_comma" class="form-control" type="text" v-model="subcontract.price_2">
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="form-row">
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="price">Kaina</label>
                            <div class="input-group">
                                <input id="price" @focus="onFocus" class="form-control" type="text" readonly v-model="price">
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="price">su PVM</label>
                            <div class="input-group">
                                <input id="vat" @focus="onFocus" class="form-control" type="text" readonly :value='(this.price * 1.21).toFixed(2)'>
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="discount">Nuolaida {{ this.discount }}</label>
                            <div class="input-group">
                                <!--<input id="discount" @focus="onFocus" class="form-control" type="text" v-model="discount">-->
                                <input id="discount" class="form-control" type="text" @keyup="calc_discount" @mouseover="set_discount">
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="price">po su Pvm</label>
                            <div class="input-group">
                                <input id="after_disc" class="form-control" type="text" readonly :value='((this.price - this.discount)* 1.21).toFixed(2)'>
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="discount">Galia</label>
                            <div class="input-group">
                                <input id="power" @focus="onFocus" class="form-control" type="text" v-model="power">
                                <div class="input-group-append">
                                    <div class="input-group-text">kW</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-6 col-lg-2">
                        <div class="form-group">
                            <label for="discount">Suvartojimas</label>
                            <div class="input-group">
                                <input id="usage" @focus="onFocus" class="form-control" type="number" v-model="usage">
                                <div class="input-group-append">
                                    <div class="input-group-text">kW</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header bg-success-light">
                                Sub klientas
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="">Vardas
                                            </label>
                                            <div class="input-group">
                                                <input id="sun_name" class="form-control" type="text"
                                                       v-model="subcontract.name">
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="">Telefonas</label>
                                            <div class="input-group">
                                                <input id="sub_phone" class="form-control" type="text"
                                                       v-model="subcontract.phone">
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="">Adresas</label>
                                            <div class="input-group">
                                                <input id="sub_address" class="form-control" type="text"
                                                       v-model="subcontract.address">
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label for="discount">Avansas
                                {{ this.payment1 }}
                            </label>
                            <div class="input-group">
                                <input id="percent1" @focus="onFocus" class="form-control" type="text"
                                       v-model="percent1">
                                <div class="input-group-append">
                                    <div class="input-group-text">%</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label for="discount">Mokėjimas
                                {{ this.payment2 }}</label>
                            <div class="input-group">
                                <input id="percent2" @focus="onFocus" readonly class="form-control" type="text"
                                       v-model="percent2">
                                <div class="input-group-append">
                                    <div class="input-group-text">%</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label for="discount">Atsiskaitymas
                                {{ this.payment3 }}</label>
                            <div class="input-group">
                                <input id="percent3" @focus="onFocus" class="form-control" type="text"
                                       v-model="percent3">
                                <div class="input-group-append">
                                    <div class="input-group-text">%</div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            <div class="card-footer">
                <button @click="update_sub" class="btn btn-outline-success">Saugoti</button>
            </div>

        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select';

    export default {
        name: "EditSub",
        props: ['oid', 'uid', 'options'],
        components: {
            vSelect,
        },
        data() {
            return {
                power: '',
                price: '',
                discount: 0,
                payment1: '',
                percent1: '',
                payment2: '',
                percent2: '',
                payment3: '',
                percent3: '',
                equipment: '',
                usage: '',
                new_equipment: '',
                new_equipment_qty: '',
                selected_equipment: [],
                equipment_to_delete: [],
                subcontract: '',
                total: '',
                id: '',
                data_loading: true,
                customer_id: ''
            }
        },
        watch: {
            percent1: function (val) {
                if (this.data_loading === false) {
                    this.payment1 = Math.round((((this.price - this.discount)*1.21 / 100) * val) / 100) * 100;
                    this.percent3 = this.payment3 = 0;
                    if (this.percent1) {
                        console.log(this.price - this.discount);
                        this.payment2 = (((this.price - this.discount) - (this.payment1 + this.payment3)) * 1.21).toFixed(2);
                        this.percent2 = 100 - this.percent1 - this.percent3;
                        if (this.payment2 < 0) {
                            this.payment1 += this.payment2;
                            this.payment2 = 0;
                        }
                    }
                    if (this.percent1 == 100) {
                        this.payment2 = 0;
                        this.percent2 = 0;
                        this.payment3 = 0;
                        this.percent3 = 0;
                    }
                }
            },

            percent3: function (val) {
                if (this.data_loading == false) {
                    this.payment3 = Math.round((((this.price - this.discount)*1.21 / 100) * val) / 100) * 100;

                    if (this.percent1 && this.percent3) {
                        this.payment2 = (((this.price - this.discount) * 1.21) - ((this.payment1 + this.payment3) * 1.21)).toFixed(2);
                        if (this.payment2 < 0) {
                            this.payment3 += this.payment2;
                            this.payment2 = 0;
                        }
                    }

                    if (this.percent3 == 100) {
                        this.payment2 = 0;
                        this.percent2 = 0;
                        this.payment1 = 0;
                        this.percent1 = 0;
                    }
                }
            },
            price: function (val) {
                if (this.data_loading == false) {
                    if (val > 999) {
                        if (this.payment1) {
                            this.payment1 = Math.round((((val - this.discount)*1.21 / 100) * this.percent1) / 100) * 100;
                        }
                        if (this.payment3) {
                            this.payment3 = Math.round((((val - this.discount) / 100)*1.21 * this.percent3) / 100) * 100;
                        }
                        if (this.percent1 && this.percent3) {
                            this.payment2 = ((this.price - this.discount) - (this.payment1 + this.payment3)) * 1.21;
                        }
                    }
                }
            },
            discount: function () {
                if (this.data_loading == false) {
                    this.percent1 = this.percent3 = '';
                }
            },

            subcontract: {
                deep: true,
                handler(val, oldVal) {
                    if (this.data_loading == false) {
                        this.price = 0;
                        let tot = this.price;
                        this.selected_equipment.forEach(function (v,i){
                            if(v.pivot.price > 0){
                                tot = tot + (Number(v.pivot.price) * v.pivot.quantity );
                            }
                        });

                        if(this.subcontract.price_1 >= 0 && this.subcontract.price_2 >= 0){
                            console.log('p12');
                            this.price = this.price + Number(this.subcontract.price_1) + Number(this.subcontract.price_2);
                        }else{
                            console.log('p2');
                            this.price = this.price + Number(this.subcontract.price_1);
                        }

                        this.price = this.price + tot;

                    }
                },

            },

            selected_equipment: {
                deep: true,
                handler(val, oldVal) {
                    if (this.data_loading == false) {
                        this.price = 0;
                        let tot = this.price;
                        this.selected_equipment.forEach(function (v,i){
                            if(v.pivot.price > 0){
                                tot = tot + (Number(v.pivot.price) * v.pivot.quantity );
                            }
                        });

                        if(this.subcontract.price_1 >= 0 && this.subcontract.price_2 >= 0){
                            console.log('p12');
                            this.price = this.price + Number(this.subcontract.price_1) + Number(this.subcontract.price_2);
                        }else{
                            console.log('p2');
                            this.price = this.price + Number(this.subcontract.price_1);
                        }

                        this.price = this.price + tot;

                    }
                },

            }
        },
        mounted() {

            axios.get('/get_equipment').then(res => {
                this.equipment = res.data
            });
            axios.get('/get_offer/' + this.$props.oid).then(res => {
                console.log(res.data);
                this.customer_id = res.data.customer_id;
                this.price = res.data.price;
                this.total = res.data.total;
                this.discount = res.data.discount;

                this.payment1 = res.data.payment1;
                this.payment2 = res.data.payment2;
                this.payment3 = res.data.payment3;

                this.percent1 = res.data.percent1;
                this.percent2 = res.data.percent2;
                this.percent3 = res.data.percent3;


                this.power = res.data.power;
                this.usage = res.data.usage;
                this.selected_equipment = res.data.equipment;
                this.subcontract = res.data.subcontract;
                //
            });


        },
        created() {
            // this.data_loading = false;
            $(document).on('select2:select', (e) => {
                console.log(e.params.data);
                this.new_equipment = e.params.data.id;
            });
        },
        methods: {
            add_equipment_to_offer() {
                this.selected_equipment.push({
                    equipment_id: this.new_equipment.id,
                    equipment_text: this.new_equipment.name,
                    quantity: this.new_equipment_qty,
                    price: this.new_equipment.price
                });
                this.price = Number(this.price) + (Number(this.new_equipment.price) * Number(this.new_equipment_qty));
                this.percent1 = this.percent3 = '';
                console.log(this.new_equipment.power);
                if (this.new_equipment.power > 0 && this.new_equipment.equipment_type_id == 1) {
                    this.power = (Number(this.power) + Number(this.new_equipment.power) * Number(this.new_equipment_qty)).toFixed(2);
                }
                this.new_equipment_qty = '';
            },
            deleteSelected(i, price, quantity) {
                this.selected_equipment.splice(i, 1);
                this.price = Number(this.price) - (Number(price) * Number(quantity));
            },
            deleteOldSelected(i, obj) {
                console.log(obj.pivot.equipment_id + ' ' + obj.pivot.offer_id);
                this.equipment_to_delete.push({'equipment_id': obj.pivot.equipment_id, 'offer_id': obj.pivot.offer_id});
                this.selected_equipment.splice(i, 1);
                this.price = Number(this.price) - (Number(obj.price) * Number(obj.pivot.quantity));

                if (obj.power > 0 && obj.equipment_type_id == 1) {
                    this.power = (Number(this.power) - Number(obj.power) * Number(obj.pivot.quantity)).toFixed(2);
                }

            },
            update_sub(e) {
                console.log(this._data);
                $(e.target).attr('disabled', true);
                // return;


                this.total = Number(this.price) - Number(this.discount);
                this.id = this.$props.oid;
                this.user_id = this.$props.uid;
                this.percent2 = (100 - this.percent1 - this.percent3);
                this.equipment = '';
                axios.post('/delete/equipment/offer', this.equipment_to_delete).then(res => {
                    console.log(res.data);
                });

                axios.post('/update_sub', this._data).then(res => {
                    console.log(res.data);
                    window.location.replace('/customer/' + res.data.customer_id)
                })
            },
            onFocus() {
                this.data_loading = false;
            },

            showWithVat(e){
                $(e.target).attr('title','su PVM '+(this.price * 1.21).toFixed(2));
            },
            deleteOrder() {
                // console.log('del'+this.$props.oid);
                if (confirm('Tikrai trinam?')) {
                    axios.delete('/delete_offer/' + this.$props.oid).then(res => {
                        console.log(res.data);
                        window.location.replace('/customer/' + res.data)
                    })
                }
            },

            calc_discount(e){
                console.log($(e.target).val());
                this.discount = ($(e.target).val().replace(',','.') / 1.21).toFixed(4);
            },

            set_discount(e){
                $(e.target).val((this.discount * 1.21).toFixed(2));
            },

            delete_comma(e){
                $(e.target).val($(e.target).val().replace(',','.'));
            },

            enter_submit(e) {
                if (e.keyCode == 13) {
                    console.log('enter');
                    this.add_equipment_to_offer();
                }

            }
        }
    }
</script>

<style scoped>

</style>